module.exports = __webpack_public_path__ + "static/media/bridge.14f41685.png";